import Win2kButton from "@/components/win2k/Win2kButton";
import type { CardData } from "./Card";
import Card from "./Card";

const ACTION_LABELS: Record<string, string> = {
  freeze: "Freeze",
  flip_three: "Flip Three",
  second_chance: "Second Chance",
};

export interface TargetInfo {
  username: string;
  roundScore: number;
  totalScore: number;
}

interface TargetPickerProps {
  pendingAction: CardData;
  targets: TargetInfo[];
  onSelectTarget: (target: string) => void;
}

export default function TargetPicker({
  pendingAction,
  targets,
  onSelectTarget,
}: TargetPickerProps) {
  const label = ACTION_LABELS[pendingAction.subtype ?? ""] ?? "Action";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-[var(--win2k-button-face)] border-2 win2k-outset p-0 max-w-xs w-full mx-4">
        <div className="bg-gradient-to-r from-[var(--win2k-title-blue-start)] to-[var(--win2k-title-blue-end)] px-2 py-1">
          <span className="text-white text-[11px] font-bold">
            Select Target — {label}
          </span>
        </div>
        <div className="p-3 space-y-3">
          <div className="flex items-center gap-2">
            <Card card={pendingAction} compact />
            <p className="text-[11px] text-[var(--win2k-button-text)]">
              Choose a player to target with <strong>{label}</strong>
            </p>
          </div>

          <div className="space-y-1">
            {targets.map((t) => (
              <Win2kButton
                key={t.username}
                className="w-full text-left"
                onClick={() => onSelectTarget(t.username)}
              >
                <span className="flex items-center justify-between gap-2">
                  <span className="font-bold text-[12px]">{t.username}</span>
                  <span className="text-[10px] text-[var(--win2k-shadow)] whitespace-nowrap">
                    round: {t.roundScore} · total: {t.totalScore}
                  </span>
                </span>
              </Win2kButton>
            ))}
          </div>

          {targets.length === 0 && (
            <p className="text-[10px] text-[var(--win2k-shadow)] italic text-center">
              No valid targets available
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
